export default __webpack_public_path__ + "static/media/polaroid_DevonportColumn.2ede84f2.png";